webpackJsonp([228012234481972],{

/***/ 275:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Glamor) {'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Template;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(26);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Template(_ref) {
	  var data = _ref.data;
	
	  var post = data.markdownRemark;
	  return Glamor.createElement(
	    'div',
	    { className: 'blog-post-container' },
	    Glamor.createElement(_reactHelmet2.default, { title: '' + post.frontmatter.title }),
	    Glamor.createElement(
	      'div',
	      { className: 'blog-post' },
	      Glamor.createElement(
	        'h1',
	        null,
	        post.frontmatter.title
	      ),
	      Glamor.createElement('div', {
	        className: 'blog-post-content',
	        dangerouslySetInnerHTML: { __html: post.html }
	      })
	    )
	  );
	}
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(8)))

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-portfolio-post-js-321b9c483ebf222d282d.js